module.exports = __webpack_public_path__ + "static/media/labelUserTemp.10e5febe.xlsx";